module.exports = __webpack_public_path__ + "static/digitalnomadhero-611b5818bb7b5c66b9b83e77977ce7ea.png";